module.exports = __webpack_public_path__ + "img/couples_02_V.1585ec61.webp";